export default "__VITE_ASSET__eaAO0j_s__"